export default __webpack_public_path__ + "images/erickson-living-icon.svg?c40e7121df797ca20f3e8a07a050c64b";